<app-loader [active]="loading || routeLoading"></app-loader>

<div *ngIf="!loading">

<app-header></app-header>

<app-floating-bar></app-floating-bar>

<router-outlet></router-outlet>

<app-footer></app-footer>

<app-scroll-top></app-scroll-top>

</div>
